import React, { useEffect } from 'react';

import OrderProduct from './orderProduct.js';
import ShippingService from '../services/shipping.js';
import OrderService from '../services/order';
import SelectedShipment from '../shipping/selectedShipment.js';
import SupplierService from '../services/supplier';
import $ from 'jquery';
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import Utility from '../utilities/utility.js';
import CurrencyService from '../services/currency.js';
import { FormCheck } from 'react-bootstrap';
import SimpleOrderProduct from './simpleOrderProduct.js';
import AuthorizationCheck from '../auth/authorizationCheck.js';
import NumberFormat from 'react-number-format';



class OrderProducts extends React.Component {

    constructor() {
        super();



        const queryParams = new URLSearchParams(window.location.search);

        this.orderId = queryParams.get('orderId');

        this.selectedShipmentId = localStorage.getItem('selectedShipment');

        this.shippingService = new ShippingService();
        this.currencyService = new CurrencyService();

        this.state = {
            orderProducts: [],

            shipment: [],
            products: [],
            order: [],
            showModal: false,
            showRemoveModal: false,
            statuses: [],
            suppliers: [],
            responseData: [],
            stockOrder: [],
            currentUserRole: '',
            timeoutId: null,
            orderSubmitted: false

        }



    }

    setRole = (role) => {

        this.setState({ currentUserRole: role });
    }

    componentDidMount() {



        try {





            const statusRequest = OrderService.statusList('order');
            const selectedShipmentRequest = !Utility.isEmpty(this.selectedShipmentId) ? this.shippingService.findShipment(this.selectedShipmentId) : null;

            const orderProductRequest = OrderService.orderProducts(this.orderId, '', '', '', '');
            const supplierRequest = SupplierService.supplierList();
            const currencyRequest = this.currencyService.currencyList();
            const orderRequest = OrderService.getOrder(this.orderId);

            const stockOrderId = localStorage.getItem('selectedStockOrder');

            const stockOrderRequest = OrderService.getOrder(stockOrderId);

            Promise.all([orderRequest, orderProductRequest, supplierRequest, statusRequest, currencyRequest, selectedShipmentRequest, stockOrderRequest])
                .then((responseData) => {



                    if (!Utility.isEmpty(responseData[0])) {


                        responseData[0].json().then(response => {


                            this.setState({ order: response });

                        });
                    }

                    if (!Utility.isEmpty(responseData[1])) {


                        responseData[1].json().then(response => {


                            this.setState({ orderProducts: response });

                        });
                    }

                    if (!Utility.isEmpty(responseData[2])) {


                        responseData[2].json().then(response => {


                            this.setState({ suppliers: response });

                        });
                    }

                    if (!Utility.isEmpty(responseData[3])) {


                        responseData[3].json().then(response => {


                            this.setState({ statuses: response });

                        });
                    }

                    if (!Utility.isEmpty(responseData[4])) {


                        responseData[4].json().then(response => {


                            this.setState({ currencies: response });

                        });
                    }





                    if (!Utility.isEmpty(responseData[5])) {


                        responseData[5].json().then(response => {
                            //console.log(response);

                            this.setState({ shipment: response });

                        });
                    }


                    if (!Utility.isEmpty(responseData[6])) {


                        responseData[6].json().then(response => {
                            console.log('stock order: ' + response);

                            this.setState({ stockOrder: response });

                        });
                    }


                });


            //this.fetchSelectedStockOrder();


        } catch (error) {

            console.log(error);
        }




    }

    searchProduct = () => {

        let timer;

        clearTimeout(this.state.timeoutId);

        timer = setTimeout(() => {
            this.orderProductList();
        }, 1500);

        this.setState({ timeoutId: timer })
    }



    orderProductList = async (e) => {

        // e.preventDefault();

        let name = $('#name').val();
        let model = $('#model').val();
        let brand = $('#brand').val();
        let size = $('#size').val();


        try {

            if (Utility.isEmpty(this.orderId)) {

                console.log('empty');

                return;
            }

            let orderId = parseInt(this.orderId);

            if (Utility.isEmpty(orderId)) {

                return;
            }

            let deleted = $('#deleted').prop('checked') ? 1 : 0;

            let changesMade = $('#changes-made').prop('checked') ? 1 : null;

            let notLoaded = $('#not-loaded').prop('checked') ? 1 : null;

            let inStock = $('#in-stock').prop('checked') ? 1 : null;

            console.log(inStock);

            let response = await OrderService.orderProducts(orderId, deleted, changesMade, name, model, brand, size, notLoaded, inStock);

            if (!response.ok) {



                return;
            }


            this.setState({ orderProducts: await response.json() });


        } catch (error) {
            console.log(error);
        }


    }



    showShipmentProducts = async () => {


        try {

            const shipmentId = localStorage.getItem('selectedShipment');

            const response = await this.shippingService.shipmentProducts(shipmentId);

            this.setState({
                products: await response.json(),
                showModal: true
            })

        } catch (error) {

            console.log(error)
        }



        /*response.then(jsonData => jsonData.json())
            .then(productData => {

                console.log('dd: ' + productData.length);
                this.setState({
                    products: productData.shipmentProducts,
                    showModal: true
                })
            })
            .catch(error => console.log(error))*/
    }




    removeShipmentProducts = (orderProductId) => {

        const response = this.shippingService.removeShipmentProducts(orderProductId);
        response.then(res => {

            if (res.ok) {

                const products = this.state.products.filter(p => p.productId != orderProductId);
                this.setState({ products: products });
            }

            return res.json();
        }).then(removeResponse => {
            console.log(removeResponse)
            $('#prd-quantity-' + orderProductId).html(removeResponse.quantity);
        }).catch(error => console.log(error));

    }

    fetchSuppliers = async () => {

        const response = await SupplierService.supplierList();

        this.setState({

            suppliers: await response.json()
        })

    }


    removeOrderProduct = async (e, orderProductId, orderId) => {

        e.preventDefault();
        try {

            const response = await OrderService.removeOrderProduct(orderProductId, orderId);

            if (response.status == 200) {

                const items = this.state.orderProducts.filter(item => item.id != orderProductId);
                this.setState({ orderProducts: items });



            } else {

                $('.error-message').before(
                    '<div class="alert alert-danger remove-alert">Probleme lors du suppression</div>'
                );

                $('.remove-alert').delay(4000).fadeOut('slow');
            }

        } catch (error) {
            $('.error-message').html(
                '<div class="alert alert-danger remove-alert">Erreur du serveur</div>'
            );

            $('.remove-alert').delay(4000).fadeOut('slow');
        }

    }




    async addProduct(productId, orderId, id) {

        try {
            let quantity = $('#order-product-quantity-' + id).val();

            if (Utility.isEmpty(quantity)) {

                return;
            }

            let response = await OrderService.addToOrder(orderId, quantity, productId);
            let data = await response.json();

            $('#prd-quantity-' + id).html(data.quantity);

        } catch (error) {

        }

    }

    updateProductQuantity = async (e, id) => {

        e.preventDefault();

        try {
            let quantity = $('#order-product-quantity-' + id).val();

            if (Utility.isEmpty(quantity) || this.state.orderSubmitted) {

                return;
            }

            let response = await OrderService.updateOrderProductQuantity(id, quantity);

            if (response.ok) {

                let responseData = await response.json();


                let orderProductData = responseData.orderProduct;
                //console.log(orderProduct.quantity);
                let orderProductList = this.state.orderProducts;

                let orderProducts = orderProductList.map(orderProduct => orderProductData.id == orderProduct.id ? orderProductData : orderProduct);

                this.setState({
                    order: responseData.order,
                    orderProducts: orderProducts,
                    orderSubmitted: false
                });

            } else {

                this.setState({ orderSubmitted: false });
            }



            /*$('#prod-quantity-' + id).html(orderProduct.quantity);

            window.location.reload();*/

        } catch (error) {

            this.setState({ orderSubmitted: false });
        }

    }

    updatePrice = async (e, id) => {

        e.preventDefault();

        try {
            let price = $('#order-product-price-' + id).val();

            let response = await OrderService.updateOrderProductPrice(id, price);

            if (response.ok) {

                let responseData = await response.json();


                let orderProduct = responseData.orderProduct;

                let order = responseData.order;

                if (!Utility.isEmpty(order)) {

                    this.setState({ order: order });




                    $('#prd-price-' + id).html(orderProduct.price);

                }





            }







        } catch (error) {

        }

    }

    addToShipment = (orderProductId, productQty, productStatus) => {



        let quantity = $('#shipment-product-quantity-' + orderProductId).val();

        if (Utility.isEmpty(this.selectedShipmentId) || productStatus != 'In Warehouse' || quantity == 0 || this.state.shipmentSubmitted) {

            $('#order-product-row-' + orderProductId).before(
                '<div class="alert alert-danger order-product-alert">Condition non remplie</div>'
            );

            $('.order-product-alert').delay(3000).fadeOut('slow');

            return;
        }



        const response = this.shippingService.addProduct(this.selectedShipmentId, orderProductId, quantity);





        response.then(res => res.json())
            .then(data => {
                if (Utility.isEmpty(data)) {

                    return;
                }

                let remainingQuantity = productQty - data.quantity;


                $('#remaining-quantity-' + orderProductId).html('Reste: ' + remainingQuantity);
                $('#total-shipped-' + orderProductId).html('Chargé: ' + data.quantity);

                console.log(data);
                $('#shipment-product-quantity-' + orderProductId).val('')
                // $('#prd-quantity-' + orderProductId).html(data.quantity);
                $('#order-product-row-' + orderProductId).before(
                    '<div class="alert alert-success order-product-alert">Produit Ajouté</div>'
                );

                $('.order-product-alert').delay(3000).fadeOut('slow');
                this.setState({ shipmentSubmitted: false });
            }).catch(error => {

                this.setState({ shipmentSubmitted: false });

                $('#order-product-row-' + orderProductId).before(
                    '<div class="alert alert-danger order-product-alert">Produit non Ajouté</div>'
                );

                $('.order-product-alert').delay(3000).fadeOut('slow');
            });

    }



    updateStatus = async (id, statusId, status) => {



        const response = await OrderService.updateOrderProductStatus(id, parseInt(statusId));

        if (response.ok) {

            window.location.reload();


        }


    }



    updateSuplier = async (orderProductId, supplierId) => {

        try {

            const response = await OrderService.setOrderProductSupplier(orderProductId, supplierId);

            if (response.ok) {

                $('#order-product-row-' + orderProductId).before(
                    '<div class="alert alert-success order-product-alert">Fournisseur mis a jour</div>'
                );
                $('.order-product-alert').delay(3000).fadeOut('slow');
            } else {

                $('#order-product-row-' + orderProductId).before(
                    '<div class="alert alert-danger order-product-alert">Probleme lors du mis a jour</div>'
                );
                $('.order-product-alert').delay(3000).fadeOut('slow');
            }

        } catch (error) {

            $('#order-product-row-' + orderProductId).before(
                '<div class="alert alert-danger order-product-alert">Probleme lors du mis a jour</div>'
            );
            $('.order-product-alert').delay(3000).fadeOut('slow');
        }


    }


    confirmRemoveOrderProduct = (e) => {

        e.preventDefault();

        this.setState({ showRemoveModal: true });
    }




    handleCloseModal = () => {

        this.setState({ showModal: false });
    }

    handleCloseRemoveModal = () => {

        this.setState({ showRemoveModal: false });
    }


    shipmentBox = (shipment) => {

        if (Utility.isEmpty(shipment)) {

            return 'No chargement choisi';
        }

        return <div className="shipment-wrapper mx-0" style={{ maxWidth: 400, textAlign: 'left' }} onClick={this.showShipmentProducts}>

            <div className="card card-default mt-2 bg-info">

                <div className="card-body">
                    <div className="row">
                        <div ><span className="font-weight-bold">No Conteneur:</span> {shipment.containerId}</div>

                        <div>Description: {shipment.description}</div>

                        <div>Destination: {shipment.destinationCountry}</div>

                        <div>Date Depart: {shipment.shippingDate}</div>

                        <div>Date D'arrivée: {shipment.arrivalDate}</div>


                    </div>
                </div>

            </div>
        </div>

    }



    fetchOrder = async () => {

        const response = await OrderService.fetchOrder(this.orderId);

        this.setState({
            order: await response.json()
        });
    }

    fetchSelectedStockOrder = async () => {

        try {

            const orderId = localStorage.getItem('selectedStockOrder');

            const response = await OrderService.fetchOrder(orderId);

            this.setState({

                stockOrder: await response.json()
            });
        } catch (error) {

            console.log(error);
        }

    }

    removeStockOrderSelection = () => {

        localStorage.setItem('selectedStockOrder', '');
        $('.order-holder').hide();
        $('.transfer-btn').remove();

    }


    /*exportProductsToExcel = (e) => {

        e.preventDefault();

        const productList = this.state.orderProducts;
        console.log(productList)
        const columns = [

            { label: "Nom", value: "name" }, // Top level data
            { label: "Modele", value: "model" }, // Custom format
            { label: "Marque", value: "brand" },
            { label: "Numero", value: "size" },
            { label: "Couleur", value: "color" },
            { label: "CPID", value: "supplierUniqueId" },
            { label: "Prix", value: "price" },
            { label: "Quantité au Cargo", value: "stockQuantity" },
            { label: "Quantité Commandée", value: "quantity" },
            { label: "Quantité Servie", value: "pickedQuantity" },
            { label: "Quantité Chargée", value: "shippedQuantity" },
            { label: "CBM", value: "cbm" },
            { label: "Poids", value: "weight" },
            { label: "Quantité Par Carton", value: "quantityInBox" },

        ];

        Utility.exportJsonToExcel("Produits Non Chargés", columns, productList);

    }*/

    exportProductsToExcel = async(e) => {
    e.preventDefault();

    const productList = this.state.orderProducts;

    const columns = [
        { label: "Image", value: "mainImage", type: "image" },
        { label: "Nom", value: "name" },
        { label: "Modele", value: "model" },
        { label: "Marque", value: "brand" },
        { label: "Numero", value: "size" },
        { label: "Couleur", value: "color" },
        { label: "CPID", value: "supplierUniqueId" },
        { label: "Prix", value: "price" },
        { label: "Quantité au Cargo", value: "stockQuantity" },
        { label: "Quantité Commandée", value: "quantity" },
        { label: "Quantité Servie", value: "pickedQuantity" },
        { label: "Quantité Chargée", value: "shippedQuantity" },
        { label: "CBM", value: "cbm" },
        { label: "Poids", value: "weight" },
        { label: "Quantité Par Carton", value: "quantityInBox" },
    ];

    await Utility.exportJsonToExcel(

    "Produits Non Chargés",

    columns,

    productList,

    {

        imageWidth: 80,

        imageHeight: 80

    }

);
};



    render() {

        const orderProductList = this.state.orderProducts;
        const shipment = this.state.shipment;
        const products = this.state.products.shipmentProducts;
        const orderDetails = this.state.order;


        let shipmentBox = this.shipmentBox(shipment);

        const selectedStockOrder = localStorage.getItem('selectedStockOrder');

        if (Utility.isEmpty(selectedStockOrder) || orderDetails.type == 'STOCK') {

            $('.order-holder').hide();
            $('.transfer-btn').remove();
        }

        let rowNumber = 0;

        return (




            <div className="container productsHolder">

                <AuthorizationCheck accessLevel='USER' userRole={this.setRole} />


                <h2>List de Produits</h2>


                <div className="form-wrapper">
                    <div className="row">
                        <div className="col">


                            <div className="form-group">
                                <input className="form-control" id="name" placeholder="Nom" onKeyUp={this.searchProduct} />
                            </div>
                        </div>
                        <div className="col">
                            <div className="form-group">
                                <input className="form-control" id="model" placeholder="Model" onKeyUp={this.searchProduct} />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">

                            <div className="form-group">
                                <input className="form-control" id="brand" placeholder="Marque" onKeyUp={this.searchProduct} />
                            </div>
                        </div>
                        <div className="col">
                            <div className="form-group">
                                <input className="form-control" id="size" placeholder="Numero ou CPID" onKeyUp={this.searchProduct} />
                            </div>
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col'>

                            <div className="form-check">
                                <input className="form-check-input" type="checkbox" value="" id="deleted" onChange={(e) => this.orderProductList()} />
                                <label className="form-check-label" style={{ float: 'left' }} for="deleted">
                                    Produits Supprimés
                                </label>
                            </div>

                            <div className="form-check">
                                <input className="form-check-input" type="checkbox" value="" id="changes-made" onChange={(e) => this.orderProductList()} />
                                <label className="form-check-label" style={{ float: 'left' }} for="changes-made">
                                    Produits Changés
                                </label>
                            </div>



                        </div>

                        <div className='col'>

                            <div className="form-check">
                                <input className="form-check-input" type="checkbox" value="" id="not-loaded" onChange={(e) => this.orderProductList()} />
                                <label className="form-check-label" style={{ float: 'left' }} for="not-loaded">
                                    Non Chargés
                                </label>
                            </div>

                            <div className="form-check">
                                <input className="form-check-input" type="checkbox" value="" id="in-stock" onChange={(e) => this.orderProductList()} />
                                <label className="form-check-label" style={{ float: 'left' }} for="in-stock">
                                    Stock au Cargo
                                </label>
                            </div>

                        </div>

                    </div>




                </div>

                <div className='order-holder float-end border rounded' style={{ width: '200px', height: '100px', position: 'absolute', zIndex: '1000', top: '5px', right: '0', padding: '5px', fontSize: '12px' }}>

                    <p>{this.state.stockOrder.description}</p>
                    <p>Date: {this.state.stockOrder.createdDate}</p>
                    <p><button className='btn btn-danger btn-sm' onClick={this.removeStockOrderSelection}>Supprime selection</button></p>
                </div>




                <Modal show={this.state.showModal} size="lg">
                    <Modal.Header closeButton onHide={this.handleCloseModal}>Chargement Produits</Modal.Header>
                    <Modal.Body>

                        <span className="error-message"></span>
                        {!Utility.isEmpty(products) && products.length > 0 && products.map(product =>



                            <div className="card card-default mt-2" key={product.id}>

                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-4">
                                            {product.name} {product.model} {product.brand} {product.color} {product.size}
                                        </div>

                                        <div className="col">
                                            <label>Quantité</label>
                                            <div>{product.quantity}</div>
                                        </div>
                                        <div className="col">
                                            <label>Prix</label>
                                            <div>{product.price}</div>
                                        </div>
                                        <div className="col"><Button onClick={() => this.removeShipmentProducts(product.productId)} className="btn btn-danger full-width-btn">X</Button></div>

                                    </div>
                                </div>

                            </div>
                        )
                        }

                    </Modal.Body>
                    <Modal.Footer>


                    </Modal.Footer>
                </Modal>



                {shipmentBox}

                <div className="messageHolder"></div>

                <div className="card card-info mt-2 bg-info">



                    <div className="card-body">
                        <div className='row'>
                            <div className='col'>Commande: {this.state.order.description}</div>
                            <div className='col text-end'>
                                <div>Montant Total: <NumberFormat
                                    defaultValue={0}
                                    value={orderDetails.total}
                                    thousandSeparator={true}
                                    displayType="text" decimalScale={2} />
                                </div>
                                <div>Poids Total: <NumberFormat
                                    defaultValue={0}
                                    value={orderDetails.weight}
                                    thousandSeparator={true}
                                    displayType="text" decimalScale={4} />
                                </div>
                                <div>CBM Total: <NumberFormat
                                    defaultValue={0}
                                    value={orderDetails.cbm}
                                    thousandSeparator={true}
                                    displayType="text" decimalScale={4} />
                                </div>

                                <div>
                                    <button className='btn btn-light' onClick={(e) => this.exportProductsToExcel(e)}>Exporter</button>
                                </div>
                            </div>

                        </div>

                    </div>

                </div>

                <div className="card card-default mt-2 bg-primary text-white">


                    <div className="card-body">
                        <div className="row">
                            <div className='col'></div>
                            <div className="col-md-3">Description</div>

                            <div className="col">Fournisseur</div>
                            <div className="col">Quantité</div>
                            <div className="col">Prix</div>
                            <div className="col-md-2"></div>
                            <div className="col-md-2"></div>
                            <div className="col text-end">Actions</div>
                            

                        </div>
                    </div>

                </div>

                {this.state.orderProducts.length > 0 && this.state.orderProducts.map(productItem =>{

                    rowNumber++;

                    return productItem.deleted == 0 || productItem.deleted == null ?
                        <OrderProduct key={productItem.id} product={productItem} suppliers={this.state.suppliers} removeOrderProduct={this.removeOrderProduct} priceUpdate={this.updatePrice}
                            updateProductQuantity={this.updateProductQuantity} type={orderDetails.type} role={this.state.currentUserRole}
                            statuses={this.state.statuses} order={this.state.order} rowNumber= {rowNumber} /> : <SimpleOrderProduct product={productItem} />

    })
                }


            </div>


        )
    }
}

export default OrderProducts;